// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_return/list_purchase_returns.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PurchaseReturnListItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListPurchaseReturnsRequest
 */
export class ListPurchaseReturnsRequest extends Message<ListPurchaseReturnsRequest> {
  /**
   * ID of the supplier for whom to list purchase returns
   *
   * @generated from field: string supplier_id = 1;
   */
  supplierId = "";

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page = 2;
   */
  page = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<ListPurchaseReturnsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListPurchaseReturnsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPurchaseReturnsRequest {
    return new ListPurchaseReturnsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPurchaseReturnsRequest {
    return new ListPurchaseReturnsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPurchaseReturnsRequest {
    return new ListPurchaseReturnsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPurchaseReturnsRequest | PlainMessage<ListPurchaseReturnsRequest> | undefined, b: ListPurchaseReturnsRequest | PlainMessage<ListPurchaseReturnsRequest> | undefined): boolean {
    return proto3.util.equals(ListPurchaseReturnsRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListPurchaseReturnsResponse
 */
export class ListPurchaseReturnsResponse extends Message<ListPurchaseReturnsResponse> {
  /**
   * List of purchase return items
   *
   * @generated from field: repeated com.neulink.pharmacy.PurchaseReturnListItem purchase_returns = 1;
   */
  purchaseReturns: PurchaseReturnListItem[] = [];

  /**
   * Total number of purchase returns available
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ListPurchaseReturnsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListPurchaseReturnsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_returns", kind: "message", T: PurchaseReturnListItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPurchaseReturnsResponse {
    return new ListPurchaseReturnsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPurchaseReturnsResponse {
    return new ListPurchaseReturnsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPurchaseReturnsResponse {
    return new ListPurchaseReturnsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPurchaseReturnsResponse | PlainMessage<ListPurchaseReturnsResponse> | undefined, b: ListPurchaseReturnsResponse | PlainMessage<ListPurchaseReturnsResponse> | undefined): boolean {
    return proto3.util.equals(ListPurchaseReturnsResponse, a, b);
  }
}

